import axios from "axios";
import {
  Button,
  IconButton,
} from "@mui/material";
import styles from "./style.module.css";
import SearchIcon from "@mui/icons-material/Search";
import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import {
  GridColDef,
  GridFilterModel,
  GridToolbar,
} from "@mui/x-data-grid";
import { CalendarIcon, LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment, { MomentInput } from "moment";
import CircularModal from '../../custom/circularModalLoader/circularModalLoader';
import ReportsTable from '../../custom/reportsTable';
import Title from '../../custom/Title';
import { getPaymentsReport } from "../../../services/Reports";
import useService from "../../../hooks/useService";
import { TRANSACTION_STATUS } from "../../../utils/constant";



export function formatDate(dateString: any) {
    return moment(dateString).format('DD-MM-YYYY');
  }

const getTwoPointNumber = (number: number) => {
  return Number(number.toFixed(2));
};

export const checkDateDifference = (fromDate: Date, toDate: Date) => {
  const fromDateObj = new Date(fromDate)
  const toDateObj = new Date(toDate)
  const differenceInTime = toDateObj.getTime() - fromDateObj.getTime()
  const differenceInDays = differenceInTime / (1000 * 3600 * 24)

  if (differenceInDays > 30) return true
  else return false
}


const pvcPaymentColumn = [
  {
    id: 'sNo',
    label: 'Sr No.',
  },
  {
    id: 'documentNumber',
    label: 'SELLNO',
  },
  {
    id: 'globalTransactionNumber',
    label: 'globalTransactionNumber',
  },
  {
    id: 'transactionType',
    label: 'transactionType',
  },
  {
    id: 'documentDate',
    label: 'SellDate',
  },
  {
    id: 'FromCustomer',
    label: 'FromCustomer',
  },
  {
    id: 'pvcName',
    label: 'FromLocation',
  },
  {
    id: 'sellType',
    label: 'SellType',
  },
  {
    id: 'SellMethod',
    label: 'SellMethod',
  },
  {
    id: 'SellPlatform',
    label: 'SellPlatform',
  },
  {
    id: 'pvcState',
    label: 'FromState',
  },
  {
    id: 'userType',
    label: 'Reference Name',
  },
  {
    id: 'referanceNo',
    label: 'Reference No',
  },
  {
    id: 'InvoiceCategory',
    label: 'InvoiceCategory',
  },
  {
    id: 'fullName',
    label: 'CustomerName',
  },
  {
    id: 'mobileNumber',
    label: 'MobileNo.',
  },
  {
    id: 'emailAddress',
    label: 'EmailId',
  },
  {
    id: 'pan',
    label: 'CustomerPANNo',
  },
  {
    id: 'GSTIN',
    label: 'CustomerGSTNNo',
  },
  {
    id: 'mobileNumberBill',
    label: 'MobileNoBilling',
  },
  // {
  //   id: 'referenceName',
  //   label: 'Reference Name',
  // },
  // {
  //   id: 'referenceNo',
  //   label: 'Reference No',
  // },
  // {
  //   id: 'totalNetWeight',
  //   label: 'TotalNetWeight',
  // },
  {
    id: 'totalGoldWeight',
    label: 'totalGoldWeight',
  },
  {
    id: 'totalGoldQuantity',
    label: 'totalGoldQuantity',//totalGoldQuantity
  },
  {
    id: 'totalSilverWeight',
    label: 'totalSilverWeight',
  },
  {
    id: 'totalSilverQuantity',
    label: 'totalSilverQuantity',
  },
  // {
  //   id: 'totalQty',
  //   label: 'TotalQty',
  // },
  {
    id: 'preTaxAmount',
    label: 'SellSubAmount',
  },
  {
    id: 'GST',
    label: 'GSTAmount',
  },
  {
    id: 'TCS',
    label: 'TCSAmount',
  },
  {
    id: 'IGST',
    label: 'IGSTAmount',
  },
  {
    id: 'CGST',
    label: 'CGSTAmount',
  },
  {
    id: 'SGST',
    label: 'SGSTAmount',
  },
  {
    id: 'discountPrecentage',
    label: 'Discount %',
  },
  {
    id: 'totalAmount', //post tax amt
    label: 'SellGrossTotal',
  },
  {
    id: 'amount',
    label: 'PaidAmount',
  },
  {
    id: 'adjustment',
    label: 'Adjustment',
  },
  {
    id: 'paymentMethod',
    label: 'PaymentMode',
  },
  {
    id: 'cardLastDigits',
    label: 'CardNo',
  },
  {
    id: 'bank',
    label: 'Bank',
  },
  {
    id: 'createdBy',
    label: 'CreatedBy',
  },
  {
    id: 'paymentCreatedAt',
    label: 'CreatedOn',
  },
  {
    id: 'paymentRemarks',
    label: 'PaymentRemarks',
  },
  {
    id: 'paymentStatus',
    label: 'SellStatus',
  },
]
export const PaymentReports = () => {
  let sessionId: any = localStorage.getItem("sessionId")
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState<any>([])
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 })
  const [totalCount, setTotalCount] = useState<number>(0)
  const [fromDate, setFromDate] = useState<any>(new Date().toString())
  const [toDate, setToDate] = useState<any>(new Date().toString())
  const [showData, setShowData] = useState([]);
  const { execute } = useService()
  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [],
    quickFilterExcludeHiddenColumns: true,
    quickFilterValues: [],
  })

  const getPaymentReport = async () => {
    try {
      let dateRange = checkDateDifference(fromDate, toDate)
    //   if (dateRange) return errorToast('Date range should be less than 30 days!')

      setLoading(true)
      const params = {
        // sessionid: sessionId,
        fromDate,
        toDate,
        // page: paginationModel.page,
        // pageSize: paginationModel.pageSize
      }

    //   const response = await axios.post(
    //     "/getPaymentsReport",
    //     params
    //   )
      const { data } = await execute(() => getPaymentsReport({params}))
      console.log("respons==", data)
      setLoading(false)
      setReportData(data || [])
    } catch (error) {
      setLoading(false)
      console.error(error)
    //   errorToast('Unable to get pvc payment report!')
    }
  }

  useEffect(() => {

    let rows: any = []
    let sNo = 1
    console.log("res", reportData)
    reportData?.forEach((data: any) => {
      data.order?.forEach((item: any) => {
        const { order, ...restData } = data
        let rowData = {
          ...restData,
          customerCity: item.customerCity,
          customerState: item.customerState,
          customerStateCode: item.customerStateCode,
          adjustment: item.adjustment,
          pvcCity: data.pvcCity,
          pvcState: data.pvcState,
          totalGoldWeight: item.totalGoldWeight,
          totalSilverWeight: item.totalSilverWeight,
          totalGoldQuantity: item.totalGoldQuantity,
          totalSilverQuantity: item.totalSilverQuantity,
          totalAmount: item.totalBill,
          documentDate: formatDate(item.createdAt),
          preTaxAmount: item.preTaxAmount,
          totalTax: (item.totalBill - item.preTaxAmount),
          GST: item?.taxes?.filter((tax: any) => tax.taxType === 'GST')[0]?.taxAmount ?? 0,
          TCS: item?.taxes?.filter((tax: any) => tax.taxType === 'TCS')[0]?.taxAmount ?? 0,
          CGST: 0,
          SGST: 0,
          IGST: 0,
        }
        if(data.transactionType === "MINTED_SALES") // for minted transaction
           rowData.GST = item.mintedGST
           
        // Calculate tax values
        if (rowData.GST) {
          if (rowData?.pvcStateCode === rowData?.customerStateCode) { // intra state GST
            rowData.CGST = getTwoPointNumber(+(rowData.GST / 2))
            rowData.SGST = getTwoPointNumber(+(rowData.GST / 2))
          } else {
            rowData.IGST = rowData.GST
          }
        }
        // Add payment details to rowData
        let paidPayments = 0.00
        if(item?.payments?.length > 0){
          item.payments.forEach((payment: any) => {
            paidPayments += payment.amount
            rows.push({
              ...rowData,
              sNo: sNo,
              paymentStatus: data.transactionStatus ==  TRANSACTION_STATUS.CANCELLED ? TRANSACTION_STATUS.CANCELLED : payment.paymentStatus == "UNPAID" ? "PENDING" : payment.paymentStatus,
              paymentMethod: payment.paymentMethod,
              paymentType: payment.paymentType,
              amount: payment.amount,
              bank: payment?.bank || 'NA',
              paymentRemarks: payment?.additionalDetails || 'NA',
              cardLastDigits: payment?.cardLastDigits || 'NA',
              billingNumber: payment?.billingNumber || 'NA',
              paymentReferenceNumber: payment?.paymentReferenceNumber || 'NA',
              paymentCreatedAt: formatDate(payment.createdAt),
            });
            sNo++
          });
          let pendingPaymentAmout = item?.totalBill - paidPayments 
          if(pendingPaymentAmout > 1 && data?.transactionStatus != TRANSACTION_STATUS.CANCELLED &&  data?.transactionStatus != TRANSACTION_STATUS.COMPLETED  ){
            rows.push({
              ...rowData,
              sNo: sNo,
              paymentStatus:  "PENDING",
              paymentMethod: "NA",
              paymentType: "NA",
              amount: paidPayments,
              bank: 'NA',
              paymentRemarks: 'NA',
              cardLastDigits: 'NA',
              billingNumber:  'NA',
              paymentReferenceNumber:  'NA',
              paymentCreatedAt: 'NA',
            });
            sNo++
          }
        }
        else{
          if(data?.transactionStatus != TRANSACTION_STATUS.CANCELLED && data?.transactionStatus != TRANSACTION_STATUS.COMPLETED){
            rows.push({
              ...rowData,
              sNo: sNo,
              paymentStatus: data?.transactionStatus ==  "PAYMENT_INITIATED" ? "PENDING" : data?.transactionStatus,
              paymentMethod: 'NA',
              paymentType: 'NA',
              amount: 0 ,
              bank: '',
              paymentRemarks: '',
              cardLastDigits: '',
              billingNumber: 'NA',
              paymentReferenceNumber: 'NA',
              paymentCreatedAt: 'NA',
            });
            sNo++
          }
         
        }
        // if(item?.payments.length > 0){
        //   item.payments.forEach((payment: any) => {
        //     rows.push({
        //       ...rowData,
        //       sNo: sNo,
        //       paymentStatus: data.transactionStatus ==  "CANCELLED" ? "CANCELLED" : payment.paymentStatus,
        //       paymentMethod: payment.paymentMethod,
        //       paymentType: payment.paymentType,
        //       amount: payment.amount,
        //       bank: payment.bank,
        //       paymentRemarks: payment.additionalDetails,
        //       cardLastDigits: payment.cardLastDigits,
        //       billingNumber: payment.billingNumber,
        //       paymentReferenceNumber: payment.paymentReferenceNumber,
        //       paymentCreatedAt: formatDate(payment.createdAt),
        //     });
        //     sNo++
        //     if(item.totalBill > payment.amount && data.transactionStatus != "CANCELLED")
        //       rows.push({
        //         ...rowData,
        //         sNo: sNo,
        //         paymentStatus:  "PENDING",
        //         paymentMethod: payment.paymentMethod,
        //         paymentType: payment.paymentType,
        //         amount: item.totalBill - payment.amount,
        //         bank: payment.bank,
        //         paymentRemarks: payment.additionalDetails,
        //         cardLastDigits: payment.cardLastDigits,
        //         billingNumber: payment.billingNumber,
        //         paymentReferenceNumber: payment.paymentReferenceNumber,
        //         paymentCreatedAt: formatDate(payment.createdAt),
        //       });
        //       sNo++
        //   });
        // }
        // else{
        //   rows.push({
        //     ...rowData,
        //     sNo: sNo,
        //     paymentStatus: data.transactionStatus ==  "PAYMENT_INITIATED" ? "PENDING" : '',
        //     paymentMethod: 'NA',
        //     paymentType: 'NA',
        //     amount: item?.totalBill || 'NA',
        //     bank: '',
        //     paymentRemarks: '',
        //     cardLastDigits: '',
        //     billingNumber: 'NA',
        //     paymentReferenceNumber: 'NA',
        //     paymentCreatedAt: 'NA',
        //   });
        //   sNo++
        // }

   
      })
    })

    console.log("row updated", rows)
    setShowData(rows)

  }, [reportData])

  const getPaymentReportColumn = () => {
    let minWidth = 100
    return pvcPaymentColumn.map((field: any) => {

      const row: GridColDef = {
        field: field.id,
        headerName: field.label,
        minWidth,
        align: 'left'
      }

      switch (field.id) {
        case "SellMethod":
          row.minWidth = 80;
          row.valueGetter = params => {
            return 'OFFLINE'
          }
          break;
        case "FromCustomer":
          row.minWidth = 230;
          row.valueGetter = params => {
            return 'MMTC-PAMP INDIA PVT. LTD.'
          }
          break;
        case "SellPlatform":
          row.minWidth = 80;
          row.valueGetter = params => {
            return 'MPIPL'
          }
          break;
        case "documentDate":
          row.valueGetter = params => {
            return params.row.documentDate
          }
          break;
        case "documentNumber":
          row.minWidth = 160
          break;
        case "globalTransactionNumber":
          row.minWidth = 140
          break;
        case "transactionType":
          row.minWidth = 160
          break;
        case "pvcName":
          row.minWidth = 290
          break;
        case "pvcState":
          row.minWidth = 130
          break;
        case "mobileNumber":
          row.minWidth = 130
          break;
        case "fullName":
          row.minWidth = 150
          break;
        case "emailAddress":
          row.minWidth = 210
          break;
        case "paymentMethod":
          row.minWidth = 190
          break;
        case "pan":
          row.minWidth = 130
          break;
        case "GSTIN":
          row.minWidth = 160
          row.valueGetter = params => {
            return params.row.customerGSTIN ? params.row.customerGSTIN : "N/A"
          }
          break;
        case "referenceNo":
          row.minWidth = 130;
          row.valueGetter = params => {
            return params.row.employeeCode ? params.row.employeeCode : "N/A"
          }
          break;
        case "referenceName":
          row.minWidth = 150
            row.valueGetter = params => {
              if (params.row.userType === 'employee')
                return 'EMPLOYEE'
              if (params.row.userType === 'F&F')
                return 'EMPLOYEE REFERAL'
              else {
                return ''; // Default return value
              }
            }
          break;
        case "sellType":
          row.minWidth = 120;
          row.valueGetter = params => {
            return params.row?.pvcState?.toLowerCase() === params.row?.customerState?.toLowerCase() ? "INTRA STATE" : "INTER STATE"
          }
          break;
        case "InvoiceCategory":
          row.minWidth = 180;
          row.valueGetter = params => {
            return params.row.customerGSTIN == '' ? "GST NON REGISTERED" : "GST REGISTERED"
          }
          break;
        case "mobileNumberBill":
          row.minWidth = 120;
          row.valueGetter = params => {
            return params.row.mobileNumber
          }
          break;
        case "userType":
          row.minWidth = 150
          break;
        case "referanceNo":
          row.minWidth = 150
          break;
          case "paymentStatus": 
          row.minWidth = 180
          break;
        default:
          row.minWidth = 100
          break;
      }
      return row;
    })
  }

  const filterModal = () => {
    return (
      <Box className={styles.filterModal}>
        <Box className={styles.filterModalRow}>
          <Box className={styles.boxModal}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <MobileDatePicker
                slotProps={{
                  textField: { fullWidth: true, size: 'small' },
                  field: {
                    InputProps: {
                      endAdornment: <IconButton><CalendarIcon /></IconButton>
                    }
                  }
                }}
                label='Start Date'
                onChange={(value) => setFromDate(value?.toString()!)}
                value={moment(fromDate)}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <MobileDatePicker
                slotProps={{
                  textField: { fullWidth: true, size: 'small' },
                  field: {
                    InputProps: {
                      endAdornment: <IconButton><CalendarIcon /></IconButton>
                    }
                  }
                }}
                label='End Date'
                onChange={(value) => setToDate(value?.toString()!)}
                value={moment(toDate || new Date().toString() as MomentInput)}
              />
            </LocalizationProvider>
          </Box>
          <Box >
            <Button
              variant="contained"
              onClick={getPaymentReport}
              endIcon={<SearchIcon />}
              disabled={!fromDate}
            >
              Apply Filter
            </Button>
          </Box>
        </Box>
      </Box>
    )
  }

  const renderTable = () => {
    return (
      <Box >
        {loading && <CircularModal thickness={4} />}
        <div style={{ height: '500px', overflow: 'auto' }}>
          <ReportsTable
            className="payrollGrid"
            rows={showData}
            columns={getPaymentReportColumn()}
            disableRowSelectionOnClick={true}
            rowHeight={50}
            fixedHeight={true}
            slots={{ toolbar: GridToolbar }}
            hideFooter={true}
            getRowId={(row) => row.sNo}

          // filterModel={filterModel}
          // onFilterModelChange={(newModel) => setFilterModel(newModel)}
          // paginationMode={"server"}
          // paginationModel={paginationModel}
          // onPaginationModelChange={setPaginationModel}
          // rowCount={totalCount}
          />
        </div>
      </Box>
    );
  }

  // useEffect(() => {
  // }, [paginationModel.page])

  return (
    <Box className={styles.container}>
    <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Payments Report</Title>
      {filterModal()}
      {renderTable()}
    </Box>
  )
}
